import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { AnalyticsService } from '@analytics/services/analytics.service';
import { Injectable } from '@angular/core';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import {
  Description,
  ItemOffer,
  Offers,
  ReplacementOffer,
} from '@dgx-pr-spa/shared/util';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductDetailsService } from '@product-details/services/product-details.service';
import { getPricegross, planType } from '@shared/helpers/function.helpers';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { tap, withLatestFrom } from 'rxjs/operators';
import * as fromGA from '../actions';

const GenerateCommonUpsellElements = (
  offer: Offers,
  upsellOffer: ItemOffer,
  productDetails: ReplacementOffer,
  replacementCost: number
) => {
  const installation = getPricegross(
    productDetails.services,
    Description.Installation
  );
  const disposal = getPricegross(productDetails.services, Description.Disposal);
  const delivery = getPricegross(productDetails.services, Description.Delivery);

  return {
    OfferType: 'Standard',
    AccountBrand: offer.current_item.make,
    Manufacturer: offer.current_item.make,
    planNumber: offer.current_plan.plan_number,
    productName: `${offer.current_item.make} ${offer.current_item.appliance_category}`,
    productModel: offer.current_item.model,
    customerType: 'G',
    PlanType: planType(offer.current_plan),
    JobReferenceNumber: offer.current_plan.reference_number,
    customerID: offer.contact_details.person_gid,

    productNameOffer: `${productDetails?.make} ${productDetails?.appliance_category}`,
    productModelOffer: productDetails.model,
    AccountBrandOffer: productDetails.make,
    ManufacturerOffer: productDetails.make,
    upgrade: productDetails.upgrade_fee,
    outstandingMonthlyPayments: offer.offer.outstanding_dd_count,
    remainingPayment: offer.offer.outstanding_dd_amount,
    totalCostReplacement: replacementCost,
    installation,
    disposal,
    delivery,
    paymentOffer: 'MPM',
    PRContinuedCover: upsellOffer.subsequentPayment,
    PRContinuedCoverVisible:
      offer?.offer.upsell_flag && upsellOffer?.itemOfferHash ? 'Yes' : 'No',
    PRGroup: 'aws',
    rrp: productDetails.rrp,
    oldPolicy: 'not available',
  };
};

@Injectable()
export class GAUpsellEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly analyticsService: AnalyticsService,
    private readonly viewOffersService: ViewOffersService,
    private readonly completeOrderService: CompleteOrderService,
    public readonly additionalServicesService: AdditionalServicesService,
    public readonly productDetailsService: ProductDetailsService
  ) {}

  CtaClicked$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGA.LinksCta),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.additionalServicesService.itemOffer$,
          this.productDetailsService.selected$,
          this.completeOrderService.replacementCost$
        ),
        tap(([action, offer, upsellOffer, productDetails, replacementCost]) => {
          const { label, eventAction, includeMetaData } = action;

          this.analyticsService.eventEmitter({
            ...(includeMetaData &&
              GenerateCommonUpsellElements(
                offer,
                upsellOffer,
                productDetails,
                replacementCost
              )),
            event: 'PRGenericGAEvent',
            eventPR: 'pr-what-included',
            eventCategory: 'Product Replacement',
            eventAction: eventAction,
            eventLabel: label,
          });
        })
      ),
    { dispatch: false }
  );

  PolicyPageLoaded$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGA.PolicyPageLoaded),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.additionalServicesService.itemOffer$,
          this.productDetailsService.selected$,
          this.completeOrderService.replacementCost$
        ),
        tap(([, offer, upsellOffer, productDetails, replacementCost]) => {
          this.analyticsService.eventEmitter({
            ...GenerateCommonUpsellElements(
              offer,
              upsellOffer,
              productDetails,
              replacementCost
            ),
            event: 'PRAWS',
            eventPR: 'pr-what-included',
            pagename: 'product-replacement-your-policy',
            genericpagename: 'product-replacement-offer',
            category: 'product-replacement',
            clientName: 'DG PR',
          });
        })
      ),
    {
      dispatch: false,
    }
  );
}
